import { call, put, takeEvery } from 'redux-saga/effects';
import request from '../../utils/request';
import errorMessages from '../../components/Error/messages';
import { getAuthToken } from '../Auth/token';
import { API_URL_WEBMASTER_STAT_CAMPAIGN_DETAIL } from '../../config';
import * as constants from './constants';
import { statCampaignDetailSuccess, statCampaignDetailError } from './actions';

function statCampaignDetailRequest(token, action) {
  const { campaign, status, dateFrom, dateTo } = action;
  const data = JSON.stringify({
    token,
    action_status: status,
    campaign_id: campaign.campaign_id,
    date_from: dateFrom,
    date_to: dateTo,
  });
  const url = `${API_URL_WEBMASTER_STAT_CAMPAIGN_DETAIL}?data=${data}`;
  const options = {
    method: 'GET',
  };

  return request(url, options);
}

function* statCampaignDetailFlow(action) {
  try {
    const token = yield getAuthToken();
    const result = yield call(statCampaignDetailRequest, token, action);
    const { response } = result;
    if (response.success === 1) {
      yield put(statCampaignDetailSuccess(response.data));
      return;
    }
    throw errorMessages.defaultMessage;
  } catch (error) {
    yield put(statCampaignDetailError(error));
  }
}

// run in parallel
export default function* rootSaga() {
  yield takeEvery(
    constants.STAT_CAMPAIGN_DETAIL_REQUEST,
    statCampaignDetailFlow,
  );
}



// WEBPACK FOOTER //
// ./src/containers/Statistics/sagas.js